export default __webpack_public_path__ + "static/techcrunch-76dab881aebb8b129580fdb67d043b11.svg";